import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Actions, Store, ofActionDispatched } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { ReactiveComponent } from 'src/app/components/shared/reactive-component';

import { Discount, TicketItem } from 'src/app/models';
import { AppSelectors } from 'src/app/store/app/app.selectors';
import { AppliedTicketDiscountError } from 'src/app/store/error/error.action';
import { TicketItemsStateSelectors } from 'src/app/store/ticket-items/ticket-items-state.selectors';
import {
  AddTicketItemDiscount,
  AddTicketItemDiscountError,
  RemoveTicketItemDiscount
} from 'src/app/store/ticket-items/ticket-items.action';
import {
  AddTicketDiscount,
  AddTicketDiscountError,
  RemoveTicketDiscount
} from 'src/app/store/tickets/tickets.action';
import { UtilStateSelector } from 'src/app/store/utils.state.selectors';

@Component({
  templateUrl: './discounts.modal.html',
  styleUrls: ['./discounts.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DiscountsModal extends ReactiveComponent {
  @ViewSelectSnapshot(AppSelectors.getDiscounts)
  readonly discounts: Discount[];
  @ViewSelectSnapshot(UtilStateSelector.getSelectedDiscountId)
  readonly selectedDiscountId: number;

  @SelectSnapshot(TicketItemsStateSelectors.getSelectedTicketItem)
  private readonly selectedTicketItem: TicketItem;

  constructor(
    private modalController: ModalController,
    private store: Store,
    private actions$: Actions
  ) {
    super();
  }

  *onSubscribe(): Iterable<Subscription> {
    yield this.actions$
      .pipe(
        ofActionDispatched(AddTicketDiscountError, AddTicketItemDiscountError)
      )
      .subscribe(({ error }) => {
        this.store.dispatch(
          new AppliedTicketDiscountError(error.error.message)
        );
      });
  }

  onAddDiscount(item: Discount) {
    let action = new AddTicketDiscount(item.id);
    if (this.selectedTicketItem) {
      action = new AddTicketItemDiscount(item.id);
    }
    this.store.dispatch(action);
  }

  onRemoveDiscount(item: Discount) {
    let action = new RemoveTicketDiscount(item.id);
    if (this.selectedTicketItem) {
      action = new RemoveTicketItemDiscount(item.id);
    }
    this.store.dispatch(action);
  }

  onCloseModal() {
    this.modalController.dismiss();
  }
}
